import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Box } from '@mui/material';

/**
 * ImageSection component displays a full-width image with a fixed height of 640px.
 * 
 * @param {Object} props - Component props
 * @param {Object} props.image - Image data from a GraphQL ImageSharp query
 */
export default function ImageSection({ image }) {
  const imageData = getImage(image);

  return (
    <Box
      sx={{
        width: '100%',
        height: '640px',
        overflow: 'hidden',
      }}
    >
      <GatsbyImage
        image={imageData}
        alt="Section image"
        style={{
          width: '100%',
          height: '100%',
        }}
        imgStyle={{
          objectFit: 'cover',
        }}
      />
    </Box>
  );
}
